import _defineProperty from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _pictureSizes, _textSizes, _tooltipAlignments, _tooltipArrowAlignmen;
import { fontSize, fontWeight, lineHeight } from "../../constants/typography";
import { NeutralColors } from "../../constants/colors";
import { GRID_UNIT } from "../../constants/design";
import styled, { css, keyframes } from 'styled-components';
import { AvatarSize, TooltipAlignment } from "./types";
var pictureSizes = (_pictureSizes = {}, _defineProperty(_pictureSizes, AvatarSize.Medium, GRID_UNIT * 4), _defineProperty(_pictureSizes, AvatarSize.Large, GRID_UNIT * 5), _pictureSizes);
var textSizes = (_textSizes = {}, _defineProperty(_textSizes, AvatarSize.Medium, fontSize.xSmall), _defineProperty(_textSizes, AvatarSize.Large, fontSize.small), _textSizes);
var shapeSizes = {
  medium: css(["transform:none;left:0;top:0;"]),
  large: css(["transform:scale(1.25);left:", "px;top:", "px;"], GRID_UNIT / 2, GRID_UNIT / 2)
};
var tooltipAlignments = (_tooltipAlignments = {}, _defineProperty(_tooltipAlignments, TooltipAlignment.Left, css(["left:0;transform:translateY(100%);"])), _defineProperty(_tooltipAlignments, TooltipAlignment.Center, css(["left:50%;transform:translateY(100%) translateX(-50%);"])), _defineProperty(_tooltipAlignments, TooltipAlignment.Right, css(["right:0;transform:translateY(100%);"])), _tooltipAlignments);
var tooltipArrowAlignments = (_tooltipArrowAlignmen = {}, _defineProperty(_tooltipArrowAlignmen, TooltipAlignment.Left, css(["transform:translateX(-50%);left:", "px;"], function (_ref) {
  var size = _ref.size;
  return size && pictureSizes[size] / 2;
})), _defineProperty(_tooltipArrowAlignmen, TooltipAlignment.Center, css(["left:50%;transform:translateX(-50%);"])), _defineProperty(_tooltipArrowAlignmen, TooltipAlignment.Right, css(["transform:translateX(50%);right:", "px;"], function (_ref2) {
  var size = _ref2.size;
  return size && pictureSizes[size] / 2;
})), _tooltipArrowAlignmen);
export var Tooltip = styled.span.withConfig({
  componentId: "sc-h71u74-0"
})(["display:block;position:absolute;z-index:1;background:", ";border-radius:4px;bottom:-6px;color:", ";padding:12px;font-size:", ";line-height:1;white-space:nowrap;opacity:0;visibility:hidden;transition:opacity 200ms,visibility 200ms;", " &::before{content:'';display:block;position:absolute;top:-6px;border-width:0 4px 6px;border-color:transparent transparent ", ";width:4px;height:6px;border-style:solid;", "}"], NeutralColors.Ink, NeutralColors.White, fontSize.x2Small, function (props) {
  return tooltipAlignments[props.alignment];
}, NeutralColors.Ink, function (props) {
  return tooltipArrowAlignments[props.alignment];
});
export var AvatarWrapper = styled.span.withConfig({
  componentId: "sc-h71u74-1"
})(["display:block;position:relative;width:min-content;"]);
export var PictureWrapper = styled.span.withConfig({
  componentId: "sc-h71u74-2"
})(["position:relative;width:", "px;height:", "px;border-radius:50%;color:", ";background:", ";display:flex;align-items:center;justify-content:center;overflow:hidden;text-transform:uppercase;&:hover,&:focus{~ ", "{opacity:1;visibility:visible;}}"], function (_ref3) {
  var size = _ref3.size;
  return size && pictureSizes[size];
}, function (_ref4) {
  var size = _ref4.size;
  return size && pictureSizes[size];
}, NeutralColors.White, function (_ref5) {
  var backgroundColor = _ref5.backgroundColor;
  return backgroundColor;
}, Tooltip);
export var AvatarText = styled.span.withConfig({
  componentId: "sc-h71u74-3"
})(["font-size:", ";font-weight:", ";line-height:", ";z-index:1;"], function (_ref6) {
  var size = _ref6.size;
  return size && textSizes[size];
}, fontWeight.medium, lineHeight.large);
export var Gravatar = styled.img.withConfig({
  componentId: "sc-h71u74-4"
})(["position:absolute;top:0;right:0;width:100%;height:100%;border-radius:50%;z-index:99;"]);
export var ShapeWrapper = styled.svg.withConfig({
  componentId: "sc-h71u74-5"
})(["position:absolute;z-index:0;", ";"], function (_ref7) {
  var size = _ref7.size;
  return size && shapeSizes[size];
});
var skeletonAnimationKeyframe = keyframes(["0%{opacity:1;}50%{opacity:0.5;}100%{opacity:1;}"]);
export var Skeleton = styled.div.withConfig({
  componentId: "sc-h71u74-6"
})(["width:", "px;height:", "px;border-radius:50%;background:", ";animation:1.5s ease-in-out 0.5s infinite ", ";"], function (_ref8) {
  var size = _ref8.size;
  return size && pictureSizes[size];
}, function (_ref9) {
  var size = _ref9.size;
  return size && pictureSizes[size];
}, NeutralColors.Grey300, skeletonAnimationKeyframe);